import { AccessTimeOutlined, VerifiedUserOutlined, WarningAmberOutlined } from "@mui/icons-material";
import { Card as MuiCard, Stack, Typography } from "@mui/material";
import Card from "components/Card";
import { palette } from "theme";

const DetailsStatus = () => {
  // TODO: потом брать с бэка
  const status = "На проверке";

  return (
    <Card
      title='Статус верификации реквизитов'
      startIcon={<VerifiedUserOutlined />}>
      <Stack spacing={2}>
        <MuiCard
          variant='outlined'
          sx={{ backgroundColor: palette.bgSwitch, boxShadow: "none" }}>
          <Stack spacing={2}>
            <Stack
              direction='row'
              spacing={2}
              alignItems='center'>
              <Typography
                variant='body16Extra'
                color='text.secondary'>
                Текущий статус
              </Typography>
              {/* TODO: парсить стили, цвет в зависимости от статуса */}
              <Stack
                direction='row'
                spacing={1}
                alignItems='center'
                sx={{
                  py: 0.5,
                  px: 1,
                  borderRadius: 999,
                  backgroundColor: palette.orangeSecondary.main,
                  color: palette.orangeSecondary.contrastText,
                }}>
                <AccessTimeOutlined fontSize='small' />
                <Typography sx={{ color: "unset", fontWeight: 600 }}>{status}</Typography>
              </Stack>
              {/* TODO: заменить на реальные данные */}
            </Stack>
            <Typography sx={{ color: palette.text.secondary }}>
              Документы поданы 19 мая 2026 · Ожидаемый срок: до 20 мая 2026
            </Typography>
          </Stack>
        </MuiCard>
        {/* TODO: проверка на статус "Проверка" */}
        {status && (
          <MuiCard
            variant='outlined'
            sx={{
              backgroundColor: palette.orangeSecondary.main,
              color: palette.orangeSecondary.contrastText,
              boxShadow: "none",
            }}>
            <Stack
              direction='row'
              spacing={1}>
              <WarningAmberOutlined fontSize='small' />
              <Typography sx={{ color: "unset" }}>
                <b>Реквизиты на проверке.</b> Выставление счетов доступно, но документы могут быть отклонены
                контрагентом до завершения верификации. Среднее время проверки — 1 рабочий день.
              </Typography>
            </Stack>
          </MuiCard>
        )}
      </Stack>
    </Card>
  );
};

export default DetailsStatus;
